var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
import { StickyHeaderContainer } from './styled';
export function ListSubHeader(props) {
    const { children, action, sticky = false } = props, rest = __rest(props, ["children", "action", "sticky"]);
    return (<StickyHeaderContainer $sticky={sticky} p="sm" alignItems="center" mx="sm" {...rest}>
      <Typography $fontSize="small" $fontWeight="medium" $appearance="100">
        {children}
      </Typography>
      {action && <Box ml="auto">{action}</Box>}
    </StickyHeaderContainer>);
}
